module.exports = __webpack_public_path__ + "img/電気回路_3_9.b57d540e.png";